import FavoriteRoundedIcon from '@mui/icons-material/FavoriteRounded';
import HdrStrongRoundedIcon from '@mui/icons-material/HdrStrongRounded';
import HomeRoundedIcon from '@mui/icons-material/HomeRounded';
import PersonRoundedIcon from '@mui/icons-material/PersonRounded';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import SortRoundedIcon from '@mui/icons-material/SortRounded';
import { motion } from 'framer-motion';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, NavLink, useLocation, useNavigate } from 'react-router-dom';
import { logoUrl } from '../../BrandLogo/Logo';
import Dropdown from '../accountDropdown/Dropdown';
import GradientCartIcon from '../Gradient icons/CartIcon';
import GradientExploreIcon from '../Gradient icons/ExploreIcon';
import GradientOpenWithIcon from '../Gradient icons/OpenWith';
import './Header.css';
// import openwithicon from "@material-ui/icons/openwith"

const gradientopenwithicon = () => (
  <>
    <svg width={0} height={0}>
      <lineargradient id="linearcolors" x1={1} y1={0} x2={1} y2={1}>
        <stop offset={0} stopcolor="rgba(241,184,74,1)" />
        <stop offset={1} stopcolor="rgba(207,113,8,1)" />
      </lineargradient>
    </svg>
    <PersonRoundedIcon sx={{ fill: "url(#linearcolors)" }} />
  </>
)





function Header({ openSidebar, slModalOpen, slModalClose, handleFormType, showBackConfirmModal, loggedIn}) {
  const [headerBgColor, setHeaderBgColor] = useState('transparent');
  const [iconColor, setIconColor] = useState('#f3a400');
  const [hideBottomBar, setHideBottomBar] = useState(false);

  // const { product, loading, error } = useSelector(
  //   (state) => state.productDetails
  // );

  

  useEffect(() => {
    const handleScroll = () => {
      if (window.pageYOffset > 300) {
        setHeaderBgColor('transparent');
      } else {
        setHeaderBgColor('transparent');
        setIconColor('#f3a400'); // Change the icon color back to the initial color
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

      const [DropDown, setDropDown] = useState(false);
      const [accountActive, setAccountActive] = useState(false);
      const cart = useSelector((state) => state.cart);
      console.log('loggedIn', loggedIn);
      const onMouseEnter = (e) => {
        e.preventDefault();

        if(window.innerWidth < 600) {
          setDropDown(false);
        } else {
          setDropDown(true);
        }
      }

      const onMouseLeave = (e) => {
        e.preventDefault();
        
        if(window.innerWidth < 600) {
          setDropDown(false);
        } else {
          setDropDown(false);
        }
      }

      // const cartQty = cart.cartItems ? Object.keys(cart.cartItems).length : 0;

      const location = useLocation();
      const navigate = useNavigate();

      const handleClick = () => {
        if (loggedIn) {
          // Navigate to the account page
          navigate('/account');
        } else {
          slModalOpen();
          handleFormType('signup');
        }
      };

      const handleClickOnLogo = () => {
        const currentPath = location.pathname;
        if (currentPath === '/checkout' || currentPath === '/payment') {
          // Navigate to the account page
          showBackConfirmModal();

        } else {
          navigate('/');
        }
      };

      const handleClickAccountMobView = () => {
          // Navigate to the account page
          navigate('/mv/account');
          setAccountActive(true);
      };

      const goBack = () => {
        window.history.back();
        console.log('BUTTON CLICKED');
      };

//  useEffect(() => {
//   if(location.pathname === `/product/${product.slug}` 
//     || location.pathname === '/cart' 
//     || location.pathname === '/checkout' 
//     || location.pathname === '/payment'){
//       setHideBottomBar(true)
//     }
//  }, [])

useEffect(() => {
  const handleScroll = () => {
    if (window.pageYOffset > 300) {
      setHeaderBgColor('#B00D23');
    } else {
      setHeaderBgColor('#B00D23');
      setIconColor('#f3a400');
    }

    // const scrollHeight = document.documentElement.scrollHeight;
    // const scrollTop = window.pageYOffset;
    // const viewportHeight = window.innerHeight;

    // if (scrollTop + viewportHeight < 0.7 * scrollHeight) {
    //   setHideBottomBar(true);
    // } else {
    //   setHideBottomBar(false);
    // }
  };

  window.addEventListener('scroll', handleScroll);
  return () => {
    window.removeEventListener('scroll', handleScroll);
  };
}, []);

const cartQty = 1;

console.log('headerBgColor', headerBgColor)

const pastelColors = [
  "linear-gradient(135deg, rgba(220, 240, 235, 0.6), rgba(255, 215, 235, 0.6), rgba(245, 235, 250, 0.6))",
  "linear-gradient(135deg, rgba(235, 220, 255, 0.6), rgba(210, 240, 230, 0.6), rgba(255, 225, 240, 0.6))",
  "linear-gradient(135deg, rgba(255, 245, 210, 0.6), rgba(250, 225, 200, 0.6), rgba(230, 200, 245, 0.6))",
  "linear-gradient(135deg, rgba(210, 240, 245, 0.6), rgba(255, 220, 200, 0.6), rgba(245, 210, 220, 0.6))",
  "linear-gradient(135deg, rgba(245, 225, 210, 0.6), rgba(235, 200, 225, 0.6), rgba(255, 240, 225, 0.6))",
];
       
  return (
    <div
    
      // className={` ${
      //   location.pathname === "/" && window.innerWidth <= 600
      //     ? "navbar_mob"
      //     : "custom_navbar"
      // } max-sm:px-2`}
      // style={{ backgroundColor: '#B00D23' }}
    >
      <motion.div
  className={`top_nav ${
    location.pathname === "/" && window.innerWidth <= 600
      ? "top_nav_mob"
      : "custom_top_nav"
  } max-sm:px-2`}
  initial={{ background: location.pathname === "/exclusive" ? "transparent" : pastelColors[0] }}
  animate={{ background: location.pathname === "/exclusive" ? "transparent" : pastelColors }}
  transition={{
    duration: 20,
    ease: "easeInOut",
    repeat: Infinity,
    repeatType: "mirror",
  }}
  style={{ backgroundSize: '300% 300%' }}
>
  {location.pathname === "/" ? (
    <span className="hamburger_menu" onClick={openSidebar}>
      <SortRoundedIcon />
    </span>
  ) : null}

        {/* {window.innerWidth < 600 &&
          location.pathname !== "/" &&
          location.pathname !== "/order-status" && (
            <span className="hdr_back_btn">
              <KeyboardBackspaceRoundedIcon
                style={{ color: "#999", fontSize: "1.8rem" }}
                onClick={goBack}
              />
            </span>
          )} */}
        {/* {window.innerWidth < 600 && location.pathname === "/order-status" && (
          <Link className="hdr_back_btn" to="/">
            <KeyboardBackspaceRoundedIcon
              style={{ color: "#999", fontSize: "1.4rem" }}
            />
          </Link>
        )} */}
        <div className="w-full h-full flex items-center justify-between px-6">
  {/* Explore Button on the Left */}
  <div className="flex items-center max-md:hidden">
    <Link
      to="/explore"
      className="text-gray-700 hover:text-black flex items-center"
    >
      <GradientExploreIcon fontSize="small" />
      <span className="ml-2 text-sm">Explore</span>
    </Link>
  </div>

  {/* Centered Logo */}
  <div className="absolute left-1/2 transform -translate-x-1/2">
    <div onClick={handleClickOnLogo} className="cursor-pointer">
      <img src={logoUrl} alt="Utkarshita.com" className="h-7 max-sm:h-6" />
    </div>
  </div>

  {/* Icons on the Right */}
  <div className="flex items-center space-x-6 max-md:hidden">
    {/* Profile Icon with Dropdown */}
    <div
      className="account_icon_li"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="desktop_hdr_icon_box">
        <GradientOpenWithIcon
          className="account_icon"
          fontSize="small"
          style={{ color: "black" }}
        />
      </div>
      {DropDown && (
        <Dropdown
          slModalOpen={slModalOpen}
          handleClick={handleClick}
          handleFormType={handleFormType}
          loggedIn={loggedIn}
        />
      )}
    </div>

    {/* Cart Icon */}
    <Link to="/cart" className="relative text-black hover:text-gray-800">
      <div className="flex items-center">
        <GradientCartIcon fontSize="small" />
      </div>
      {cartQty > 0 && (
        <span className="absolute top-0 right-0 inline-block w-4 h-4 text-xs text-white bg-red-500 rounded-full text-center">
          {cartQty}
        </span>
      )}
    </Link>
  </div>
</div>

      </motion.div>
      {/* <div className='header_Bottom_bdr'>

            </div> */}

      {/* Bottom nav */}
      <div className={hideBottomBar ? "bottom_nav_none" : "bottom_nav"}>
        <NavLink className="buttons" to="/">
          <HomeRoundedIcon className="home_btm_icon" fontSize="small" />
          <span>Home</span>
        </NavLink>

        <NavLink className="buttons" to="/explore">
          <HdrStrongRoundedIcon className="explore_btm_icon" fontSize="small" />
          <span>Explore</span>
        </NavLink>

        <div
          className={`buttons ${
            accountActive ? "active-account" : "inactive-account"
          }`}
          onClick={handleClickAccountMobView}
        >
          <PersonRoundedIcon className="account_btm_icon" fontSize="small" />
          <span>Account</span>
        </div>

        <NavLink className="buttons" to="/favorites">
          <FavoriteRoundedIcon className="favorite_btm_icon" fontSize="small" />
          <span>Favorites</span>
        </NavLink>

        <NavLink className="buttons bottom_nav_cart_box" to="/cart">
          <div>
            <ShoppingCartIcon className="cart_btm_icon" fontSize="small" />
            <span>Cart</span>
            <span
              className={cartQty > 0 ? "cart_i_qty_gtz" : "cart_i_qty_none"}
            >
              {cartQty}
            </span>
          </div>
        </NavLink>
      </div>
    </div>
  );
}

export default Header

